// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import global from '../config/global'
import 'font-awesome/css/font-awesome.css'

Vue.prototype.axios = axios

Vue.config.productionTip = false
Vue.prototype.$global = global

Vue.use(ElementUI)

window._AMapSecurityConfig = {
  securityJsCode: '8505076774e8393ed5a669b4d4921a92'
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js